import React, { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import { Workspace } from '../../types/files';
import storage from '../../utils/storage';

export type WorkspacesTableFilters = {
  sectors?: string[],
  stages?: string[],
  geography?: string[],
};

type WorkspacesTableContextProps = {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  columns: string[] | undefined;
  setColumns: Dispatch<SetStateAction<string[] | undefined>>;
  rows: Workspace[] | undefined;
  setRows: Dispatch<SetStateAction<Workspace[] | undefined>>;
  filters: WorkspacesTableFilters;
  setFilters: Dispatch<SetStateAction<WorkspacesTableFilters>>;
  hoverAnchor: (HTMLElement|null)[];
  setHoverAnchor: Dispatch<SetStateAction<(HTMLElement|null)[]>>;
  hoverField: string;
  setHoverField: Dispatch<SetStateAction<string>>;
  hoverWorkspace: Workspace | null;
  setHoverWorkspace: Dispatch<SetStateAction<Workspace | null>>;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
};

export const InitDashboardsTable: WorkspacesTableContextProps = {
  loading: false,
  setLoading: () => {},
  columns: [],
  setColumns: () => {},
  rows: undefined,
  setRows: () => {},
  filters: {},
  setFilters: () => {},
  hoverAnchor: [],
  setHoverAnchor: () => {},
  hoverField: '',
  setHoverField: () => {},
  hoverWorkspace: null,
  setHoverWorkspace: () => {},
  sortBy: 'Added',
  setSortBy: () => {},
};

export const WorkspacesTableContext = createContext<WorkspacesTableContextProps>(InitDashboardsTable);

const WorkspacesTableProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [columns, setColumns] = useState<string[] | undefined>(undefined);
  const [rows, setRows] = useState<Workspace[] | undefined>(undefined);
  const [filters, setFilters] = useState<WorkspacesTableFilters>({
    sectors: [], stages: [], geography: []
  });
  const [hoverAnchor, setHoverAnchor] = useState<(HTMLElement|null)[]>([]);
  const [hoverField, setHoverField] = useState<string>('');
  const [hoverWorkspace, setHoverWorkspace] = useState<Workspace|null>(null);
  const [sortBy, setSortBy] = useState<string>('Added');

const contextValue = useMemo(() => ({
    loading,
    setLoading,
    columns,
    setColumns,
    rows,
    setRows,
    filters,
    setFilters,
    hoverAnchor,
    setHoverAnchor,
    hoverField,
    setHoverField,
    hoverWorkspace,
    setHoverWorkspace,
    sortBy,
    setSortBy,
  }), [
    loading,
    setLoading,
    columns,
    setColumns,
    rows,
    setRows,
    filters,
    setFilters,
    hoverAnchor,
    setHoverAnchor,
    hoverField,
    setHoverField,
    hoverWorkspace,
    setHoverWorkspace,
    sortBy,
    setSortBy,
  ]);

  if (storage.getItem('config.logger-context'))
    console.log("CTX", ["WorkspacesTable", contextValue]);

  return (
    <WorkspacesTableContext.Provider value={contextValue}>
      {children}
    </WorkspacesTableContext.Provider>
  );
};

export default WorkspacesTableProvider;
